// extracted by mini-css-extract-plugin
module.exports = {"modal-content":"_93444fe79c--modal-content--LrWsF","close":"_93444fe79c--close--synXP"};